import isNil from 'lodash/isNil';

export const DEFAULT_AVATAR = 'https://d1a370nemizbjq.cloudfront.net/e335336e-d0d7-4adf-bd8a-e398e5a55cb7.glb';
export const AVATAR_CIRCLE_RADIUS = 0.7; // the circle radius

export class Avatar {
  name: string;

  url: string;

  positionX: number;

  positionY: number;

  positionZ: number;

  rotationX: number;

  rotationY: number;

  rotationZ: number;

  quaternionX: number;

  quaternionY: number;

  quaternionZ: number;

  quaternionW: number;

  uuid: string;

  color: string;

  muted: boolean;

  visible?: boolean;

  degree?: number;

  constructor(model: any = {}) {
    this.name = model.name || '';
    this.url = model.url;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.quaternionX = model.quaternionX || 0;
    this.quaternionY = model.quaternionY || 0;
    this.quaternionZ = model.quaternionZ || 0;
    this.quaternionW = model.quaternionW || 0;
    this.uuid = model.uuid || null;
    this.color = model.color || '0xEA475C';
    this.muted = isNil(model.muted) || model.muted;
    this.visible = typeof model.visible === 'boolean' ? model.visible : true;
    this.degree = model.degree || null;
  }
}
